import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import { Component, Input, OnInit, HostListener, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { CartService } from '../../shared/services/cart.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BuyNowButtonComponent } from '../buy-now-button/buy-now-button.component';
import { BuyNowPopupComponent } from '../buy-now-popup/buy-now-popup.component';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../../shared/services/loader.service';
import { ScrapCertificateService } from '../../shared/services/scrap-certificate.service';
import { ScrapCertificateModalComponent } from '../../shared/components/scrap-certificate-modal/scrap-certificate-modal.component';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ProductNamePipe } from '../../shared/pipes/product-name.pipe';
import { DeliveryDateService } from '../../shared/services/delivery-date.service';

@Component({
  selector: 'app-wishlist',
  standalone: true,
  imports: [CommonModule, BreadcrumComponent, FormsModule, RouterModule, BuyNowButtonComponent, BuyNowPopupComponent, ScrapCertificateModalComponent, ProductNamePipe],
  templateUrl: './wishlist.component.html',
  styleUrl: './wishlist.component.scss',
})
export class WishlistComponent implements OnInit {
  @Input() isStandalone: boolean = true;
  wishlistBreadcrumbs: any[] = [{ label: 'My Wishlist', url: null }];
  wishlistItems: any[] = [];
  searchTerm: string = '';
  sub: Subscription = new Subscription();
  partNumber_list: any;
  productData: any;
  products: any[] = []; // Initialize as empty array
  originalProducts: any[] = [];
  itemAddedToCart = new Map<string, boolean>(); // Track success state for each product by part number

  // Buy/Book Now state
  isBuyNowPopupOpen: boolean = false;
  selectedProductForBuyNow: any = null;
  showScrapCertificateModal = false;

  showSortPopup: boolean = false;
  showFilterPopup: boolean = false;
  selectedSortOption: string = '';
  selectedFilterOption: string = 'all';

  showDesktopSortDropdown: boolean = false;
  showDesktopFilterDropdown: boolean = false;

  sortOptions = [
     
    { value: 'recently_added', label: 'Recently added' },
    { value: 'price_low_high', label: 'Price (low - high)' },
    { value: 'price_high_low', label: 'Price (high - low)' },
  ];

  filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'scrap', label: 'Scrap' },
  ];

  constructor(
    private apiService: ApiService,
    private cartService: CartService,
    private router: Router,
    private loaderService: LoaderService,
    private elementRef: ElementRef,
    private scrapCertificateService: ScrapCertificateService,
    private behaviourSubject: BehaviourSubjectService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private deliveryDateService: DeliveryDateService
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const isSortButton = target.closest('[data-sort-button]');
    const isFilterButton = target.closest('[data-filter-button]');

    if (!isSortButton && this.showDesktopSortDropdown) {
      this.closeDesktopSortDropdown();
    }

    if (!isFilterButton && this.showDesktopFilterDropdown) {
      this.closeDesktopFilterDropdown();
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth <= 640) {
      this.closeDesktopSortDropdown();
      this.closeDesktopFilterDropdown();
    } else {
      this.closeSortPopup();
      this.closeFilterPopup();
    }
  }

  ngOnInit(): void {
    // Initialize with empty string to show 'Sort By' as default
    this.selectedSortOption = '';
    this.loadWishlist();

    // Sync scrap certificate modal state with shared service
    this.sub.add(
      this.scrapCertificateService.showScrapCertificateModal$.subscribe((show) => {
        this.showScrapCertificateModal = show;
        this.cdr.detectChanges();
      })
    );
  }

  removeItem(item: any) {
  }

  viewSimilarParts(item: any) {
    localStorage.removeItem('filterState');
    this.router.navigate(['/product-list']);
    this.router.navigate(['/product-product/'], {
      queryParams: { from: 'wishlist' },
    });
  }

  loadWishlist() {
    this.loaderService.show();

    const payload: any = {
      action_type: 'get',
      is_profile: true,
      part_type:
        this.selectedFilterOption === 'all'
          ? ''
          : this.selectedFilterOption === 'scrap'
          ? 'Scrap Part'
          : '',
      offset: 0,
      limit: 10,
      ...this.getSortPayload(this.selectedSortOption),
    };

    this.sub.add(
      this.apiService.getWishlistData(payload).subscribe({
        next: (res) => {
          this.wishlistItems = res?.data?.part_list || [];
          this.productData = this.wishlistItems;
          this.products = this.productData || []; // Ensure it's always an array
          this.originalProducts = [...(this.productData || [])];

          // Initialize quantity/unit defaults for Buy/Book Now popup behavior
          if (Array.isArray(this.products)) {
            this.products.forEach((product: any) => {
              product.selectedUnit = product.selectedUnit || 'ton';
              // For used parts, set quantity to 1 or available stock (whichever is smaller)
              // For scrap parts, keep the current logic
              if (product.part_type === 'Used Part') {
                const availableStock = product.fix_quantity || 0;
                product.quantity = product.quantity || Math.min(1, availableStock);
              } else {
                product.quantity = product.quantity || '';
              }
              product.customKgQuantity = product.customKgQuantity ?? null;
              product.customTonQuantity = product.customTonQuantity ?? '';
            });
          }

          this.partNumber_list = this.wishlistItems.map(
            (item: any) => item.part_number
          );

          if (this.partNumber_list.length > 0) {
          }
        },
        error: () => {
          this.wishlistItems = [];
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      })
    );
  }

  private getSortPayload(option: string) {
    const sortOptions: Record<string, { key: string; value: string }> = {
      recently_added: { key: 'sort_by_db', value: '-created_dt' },
      price_low_high: { key: 'sort_by_db', value: 'price' },
      price_high_low: { key: 'sort_by_db', value: '-price' },
    };

    // If no option is selected, default to recently_added
    const effectiveOption = option || 'recently_added';
    const selected = sortOptions[effectiveOption];
    return selected ? { [selected.key]: selected.value } : {};
  }

  searchWishlist() {
    if (!this.originalProducts || !Array.isArray(this.originalProducts)) {
      return;
    }

    if (!this.searchTerm) {
      this.products = [...this.originalProducts];
      return;
    }

    const term = this.searchTerm.toLowerCase();
    this.products = this.originalProducts.filter(
      (item: any) =>
        (item?.short_desc_s &&
          item?.short_desc_s.toLowerCase().includes(term)) ||
        (item?.part_number && item?.part_number.toLowerCase().includes(term)) ||
        (item?.BRANCH_NAME_s &&
          item?.BRANCH_NAME_s.toLowerCase().includes(term))
    );
  }

  removeFromWishlist(item: any) {
    this.loaderService.show();
    const payload = {
      action_type: 'delete',
      wishlist_id_list: [item?.part_number],
    };
    this.sub.add(
      this.apiService.addToWishlist(payload).subscribe({
        next: () => {
          this.loadWishlist();
          this.loaderService.hide();
        },
        error: (err: Error) => {
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      })
    );
  }

  filteredWishlistItems() {
    if (!this.searchTerm) return this.wishlistItems;
    const term = this.searchTerm.toLowerCase();
    return this.products.filter(
      (item: any) =>
        (item?.short_desc_s &&
          item?.short_desc_s.toLowerCase().includes(term)) ||
        (item?.part_number && item?.part_number.toLowerCase().includes(term))
    );
  }

  gotoProductDetails(data: any) {
    localStorage.removeItem('product_categoryType');
    localStorage.setItem(
      'product_categoryType',
      JSON.stringify(data?.part_type)
    );
    this.router.navigate(['/product-detail/' + data?.part_number], {
      queryParams: { preserveScroll: 'true' }
    });
  }

  onBuyNow(productData: any) {
    // For scrap parts, require explicit valid quantity selection before proceeding
    if (productData?.part_type === 'Scrap Part') {
      productData.quantityTouched = true;
      this.cdr.detectChanges();
      if (this.shouldDisableButtons(productData)) {
        return;
      }
    }
    // Check if this is a scrap part
    if (this.scrapCertificateService.isScrapPart(productData)) {
      // Check if user is logged in first
      let userData = {};
      try {
        const userDataString = localStorage.getItem('userData1');
        if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
          userData = JSON.parse(userDataString);
        }
      } catch (error) {
        console.error('Error parsing userData1 from localStorage:', error);
      }
      if (!userData || !(userData as any)?.id) {
        this.openLoginPopup();
        return;
      }
      
      // For scrap parts, check certificate match before proceeding to buy now
      this.scrapCertificateService.handleAddToCart(
        productData,
        () => {
          // Callback for when certificate matches - proceed with buy now
          this.selectedProductForBuyNow = productData;
          this.isBuyNowPopupOpen = true;
        },
        () => {
          // Callback for login required
          this.openLoginPopup();
        }
      );
      return;
    }
    
    // For non-scrap parts, proceed with buy now directly
    this.selectedProductForBuyNow = productData;
    this.isBuyNowPopupOpen = true;
  }

  onPaymentSuccess(event: any) {
    // Hide loader if any and close popup
    this.loaderService.hide();
    this.closeBuyNowPopup();

    // Navigate to order confirmation
    if (event && event.data) {
      this.router.navigate(['/order-confirmation'], {
        state: { orderDetail: event.data },
      });
    } else {
      this.router.navigate(['/order-confirmation']);
    }
  }

  closeBuyNowPopup() {
    this.isBuyNowPopupOpen = false;
    this.selectedProductForBuyNow = null;
  }

  getQuantityForPopup(product: any): number {
    if (!product) return 1;
    
    if (product.selectedUnit === 'kg') {
      return product.customKgQuantity ? parseFloat(product.customKgQuantity) : 1;
    }
    
    // For ton units, check if custom quantity is used
    let tonQuantity = 0;
    if (product.quantity === 'custom') {
      tonQuantity = product.customTonQuantity ? parseFloat(product.customTonQuantity) : 1;
    } else {
      tonQuantity = product.quantity || 1;
    }
    
    // For used parts, ensure quantity doesn't exceed available stock
    if (product.part_type === 'Used Part') {
      const availableStock = product.fix_quantity || 0;
      return Math.min(tonQuantity, availableStock);
    }
    
    return tonQuantity;
  }

  addToCart(event: Event, partNumber: any) {
    event.stopPropagation();

    // For scrap parts, require explicit valid quantity selection before proceeding
    if (partNumber?.part_type === 'Scrap Part') {
      partNumber.quantityTouched = true;
      this.cdr.detectChanges();
      if (this.shouldDisableButtons(partNumber)) {
        return;
      }
    }

    // Stock availability check
    if (!this.checkStockAvailability(partNumber)) {
      return;
    }

    // Use the shared service to handle scrap part detection
    this.cartService.handleAddToCart(
      partNumber, // Pass the product data
      'Store Pickup',
      this.getQuantityForPopup(partNumber),
      partNumber.selectedUnit === 'kg' ? 'Kg' : 'Ton',
      () => {
        // Callback for non-scrap parts
        this.addToCartForNonScrapParts(partNumber);
      },
      () => {
        // Callback for login required
        this.openLoginPopup();
      }
    );
  }

  /**
   * Validates stock availability before adding to cart
   * Checks available quantity (stock - reserved) against requested quantity
   */
  private checkStockAvailability(product: any): boolean {
    if (!product) return false;

    // Get stock and reserved quantities from API response
    const stockQuantity = Number(product.stock_quantity_s || product.STOCK_QUANTITY_s) || 0;
    const reservedQuantity = Number(product.reserved_quantity || product.RESERVED_QUANTITY_s) || 0;
    const availableQuantity = product.available_quantity !== undefined 
      ? Number(product.available_quantity) 
      : stockQuantity - reservedQuantity;

    // For wishlist, quantity is typically 1 unless specified
    const requestedQuantity = product.total_quantity || 1;

    // Check if available stock exists and if requested quantity exceeds it
    if (availableQuantity > 0 && requestedQuantity > availableQuantity) {
      const errorMsg = `Quantity exceeds available stock. Available quantity is ${availableQuantity} units.`;
      // this.notificationService.error(errorMsg);
      return false;
    }

    // Check if no stock available
    if (availableQuantity <= 0) {
      // this.notificationService.error('This product is currently out of stock.');
      return false;
    }

    return true;
  }

  private addToCartForNonScrapParts(partNumber: any): void {
    let userData = {};
    try {
      const userDataString = localStorage.getItem('userData1');
      if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
        userData = JSON.parse(userDataString);
      }
    } catch (error) {
      console.error('Error parsing userData1 from localStorage:', error);
    }
    if (!userData || !(userData as any)?.id) {
      const productData = this.products.find(
        (product: any) => product.inventory_id === partNumber?.inventory_id
      );
      if (productData) {
        // Get quantity and unit for scrap parts
        const quantity = this.getQuantityForPopup(productData);
        const unit = productData.selectedUnit === 'kg' ? 'Kg' : 'Ton';
        
        this.cartService.addToLocalStorage(productData, 'Store Pickup', quantity, unit);
        // Mark as added to cart
        this.itemAddedToCart.set(partNumber?.inventory_id, true);
        this.cdr.detectChanges();
      }
      return;
    }
    localStorage.removeItem('addtocartpart_type');
    localStorage.setItem('addtocartpart_type', partNumber?.part_type);

    // Get quantity and unit for scrap parts
    const quantity = this.getQuantityForPopup(partNumber);
    const unit = partNumber.selectedUnit === 'kg' ? 'Kg' : 'Ton';

    this.sub.add(
      this.cartService.addToCart(partNumber?.inventory_id, 'Store Pickup', quantity, unit).subscribe({
        next: () => {
          // Mark as added to cart
          this.itemAddedToCart.set(partNumber?.inventory_id, true);
          this.cdr.detectChanges();
        },
        error: (err: Error) => {
          console.error('Error adding to cart:', err);
          this.itemAddedToCart.set(partNumber?.inventory_id, false); // Mark as failed
        },
        complete: () => {
          // No loader needed
        },
      })
    );
  }

  goToCart() {
    this.cartService.navigateToCart();
  }

  goToCartWithEvent(event: Event) {
    event.stopPropagation(); // Prevent navigation to product details
    this.cartService.navigateToCart();
  }

  openLoginPopup() {
    // Use the shared login modal service
    this.behaviourSubject.openLoginModal('other');
  }

  ngOnDestory() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  openSortPopup() {
    this.showSortPopup = true;
  }

  closeSortPopup() {
    this.showSortPopup = false;
  }

  openFilterPopup() {
    this.showFilterPopup = true;
  }

  closeFilterPopup() {
    this.showFilterPopup = false;
  }

  openDesktopSortDropdown() {
    this.showDesktopSortDropdown = true;
    this.showDesktopFilterDropdown = false;
  }

  closeDesktopSortDropdown() {
    this.showDesktopSortDropdown = false;
  }

  openDesktopFilterDropdown() {
    this.showDesktopFilterDropdown = true;
    this.showDesktopSortDropdown = false;
  }

  closeDesktopFilterDropdown() {
    this.showDesktopFilterDropdown = false;
  }

  openSort() {
    if (window.innerWidth <= 640) {
      this.openSortPopup();
    } else {
      this.openDesktopSortDropdown();
    }
  }

  openFilter() {
    if (window.innerWidth <= 640) {
      this.openFilterPopup();
    } else {
      this.openDesktopFilterDropdown();
    }
  }

  selectSortOption(option: string) {
    this.selectedSortOption = option;
  }

  selectSortOptionAndClose(option: string) {
    this.selectedSortOption = option;
    this.loadWishlist();
    this.closeDesktopSortDropdown();
  }

  getSortOptionLabel(value: string): string {
    const option = this.sortOptions.find((opt) => opt.value === value);
    return option ? option.label : '';
  }

  selectFilterOptionAndClose(option: string) {
    this.selectedFilterOption = option;
    this.loadWishlist();
    this.closeDesktopFilterDropdown();
  }

  getFilterOptionLabel(value: string): string {
    const option = this.filterOptions.find((opt) => opt.value === value);
    return option ? option.label : '';
  }

  selectFilterOption(option: string) {
    this.selectedFilterOption = option;
  }

  applySort() {
    this.loadWishlist();
    this.closeSortPopup();
  }

  applyFilter() {
    if (this.selectedFilterOption) {
    }
    this.loadWishlist();
    this.closeFilterPopup();
  }

  onQuantityChange(product: any, event: any) {
    const selectedQuantity = event.target.value;
    product.quantity = parseInt(selectedQuantity);
    product.quantityTouched = true;
  }

  onTonQuantitySelect(product: any, event: any) {
    const value = event.target.value;
    product.quantityTouched = true;
    
    if (value === 'custom') {
      product.quantity = 'custom';
      product.customTonQuantity = '';
      // Focus the input field after Angular updates
      setTimeout(() => {
        const customInput = document.querySelector(`#customInput-${product.part_number}`) as HTMLInputElement;
        if (customInput) {
          customInput.focus();
        }
      }, 0);
    } else if (value) {
      product.quantity = parseFloat(value);
      product.customTonQuantity = '';
    } else {
      product.quantity = '';
      product.customTonQuantity = '';
    }
  }

  onCustomTonQuantityInput(product: any, event: any) {
    const value = event.target.value;
    product.customTonQuantity = value;
    product.quantityTouched = true;
  }

  /**
   * Handles blur event for quantity inputs - keeps error visible
   */
  onQuantityBlur(product: any) {
    // Simply ensure quantityTouched stays true
    // Don't reset quantity - let error persist if invalid
    product.quantityTouched = true;
  }

  onKgQuantityChange(product: any, event: any) {
    const value = event.target.value;
    product.customKgQuantity = value;
    product.quantityTouched = true;
  }

  /**
   * Gets the current quantity display for a product
   */
  onUnitChange(product: any, event: any) {
    const selectedUnit = event.target.value;
    product.selectedUnit = selectedUnit;
    product.quantityTouched = true;

    if (selectedUnit === 'kg') {
      // When switching to kg, reset ton quantities
      product.quantity = '';
      product.customTonQuantity = '';
      // When switching to kg, reset custom quantity if not set
      if (!product.customKgQuantity) {
        product.customKgQuantity = '';
      }
    } else {
      // When switching to ton, reset to empty/default quantity
      product.quantity = '';
      product.customTonQuantity = '';
      product.customKgQuantity = null;
    }
  }

  /**
   * Gets the selected quantity for a product based on the current unit
   * Returns quantity in kg for consistent comparison
   */
  getSelectedQuantity(product: any): number {
    if (!product) return 0;

    if (product.selectedUnit === 'kg') {
      // For kg units, return custom kg quantity or 0 if not set
      return product.customKgQuantity ? parseFloat(product.customKgQuantity) : 0;
    } else {
      // For ton units, check if custom quantity is used
      let tonQuantity = 0;
      if (product.quantity === 'custom') {
        tonQuantity = product.customTonQuantity ? parseFloat(product.customTonQuantity) : 0;
      } else {
        tonQuantity = product.quantity || 0;
      }
      // Convert to kg (1 ton = 1000 kg)
      return tonQuantity * 1000;
    }
  }

  /**
   * Gets the available quantity for a product in kg
   */
  getAvailableQuantity(product: any): number {
    if (!product) return 0;

    return (
      product.max_booking_qty ||
      product.max_booking_quantity ||
      product.max_quantity ||
      product.available_quantity ||
      product.fix_quantity ||
      0
    );
  }

  /**
   * Validates if the selected quantity is available
   * Compares quantities in kg for consistency
   */
  isQuantityAvailable(product: any): boolean {
    const selectedQuantityInKg = this.getSelectedQuantity(product);
    const availableQuantityInKg = this.getAvailableQuantity(product);
    const minQuantityInKg = product.min_quantity || product.min_qty || 0;

    if (selectedQuantityInKg <= 0) return false;
    if (minQuantityInKg > 0 && selectedQuantityInKg < minQuantityInKg) return false;
    if (availableQuantityInKg > 0 && selectedQuantityInKg > availableQuantityInKg) return false;

    return true;
  }

  /**
   * Converts fix_quantity to tons
   * Assumes fix_quantity is in kg
   */
  getStockInTons(product: any): number {
    if (!product || !product.fix_quantity) return 0;
    
    // Convert kg to tons (1 ton = 1000 kg)
    return Math.floor(product.fix_quantity / 1000);
  }

  /**
   * Generates ton dropdown options based on available stock
   */
  getTonOptions(product: any): number[] {
    const stockInTons = this.getStockInTons(product);
    const options: number[] = [];
    
    // Generate options from 1 to available stock in tons
    // Maximum 10 options to keep dropdown manageable
    const maxOptions = Math.min(stockInTons, 10);
    
    for (let i = 1; i <= maxOptions; i++) {
      options.push(i);
    }
    
    return options;
  }

  /**
   * Checks if the product should be disabled due to quantity validation
   */
  shouldDisableButtons(product: any): boolean {
    if (!product) return true;
    if (product.part_type === 'Scrap Part') {
      const touched = !!product.quantityTouched;
      return !touched || !this.isQuantityAvailable(product);
    }
    // For Used Parts, validate against fix_quantity only if it's available
    const selectedQty = this.getSelectedQuantity(product);
    const availableQty = this.getAvailableQuantity(product);
    // If fix_quantity is not set or 0, don't disable (allow add to cart/buy now)
    if (availableQty === 0) {
      return false;
    }
    return selectedQty > availableQty;
  }

  /**
   * Get formatted delivery date (3 business days from today)
   */
  getDeliveryDate(): string {
    return this.deliveryDateService.calculateDeliveryDate(3);
  }
}
